import React from 'react';
import { Alert, AlertProps, Stack, Typography } from '@mui/material';
import { MESSAGE_SEVERITY } from './const';

export interface MessageBoxProps extends AlertProps {
  severity?: MESSAGE_SEVERITY;
  message?: React.ReactNode;
  footerAction?: React.ReactNode;
  testID: string;
}

const MessageBox = ({
  message,
  title,
  testID,
  footerAction,
  ...props
}: MessageBoxProps) => {

  return (
    <Alert
      {...props}
      data-test-id={`${testID}-message-box`}
    >
      {title && <Typography variant='body2Bold' data-test-id={`${testID}-title`}>
        {title}
      </Typography>}

      <Stack spacing={1}>
        {message && <Typography
          variant='body2'
          component='div'
          data-test-id={`${testID}-message`}>
          {message}
        </Typography>}

        {footerAction && <Typography variant='button' data-test-id={`${testID}-action`}>
          {footerAction}
        </Typography>}
      </Stack>
    </Alert>
  );
};

export default MessageBox;